





































































import { Component, Vue } from 'vue-property-decorator';
import NOC from '@/class/common/const' ;
import AccountModalBase from '@/parts/account/AccountModalBase.vue';


export default Vue.extend({
  name: 'PaymentModal',
  components: {
    AccountModalBase,
  },
  props: {
    accountData: Object,
    isClickedRegist: Boolean,
    select: {
      default: 0,
      type: Number,
    },
  },
  computed: {
    NOSELECT(): number {
      return NOC.PAYMENT.NOSELECT;
    },
    CREDIT(): number {
      return NOC.PAYMENT.CREDIT;
    },
    BANK(): number {
      return NOC.PAYMENT.BANK;
    },
  },
  data() {
    return {
      modalTitle: '',
      isConfirmScreen: false,
      isConfirmCredit: false,
      selectPayment: NOC.PAYMENT.NOSELECT,
    };
  },
  mounted() {
    this.selectPayment = this.accountData.payment;
    this.accountData.noTaxPrice = Math.ceil(this.accountData.taxPrice / 11 * 10);
    if (this.isClickedRegist) {
      this.modalTitle = 'お申込み情報の登録';
    } else {
      // TODO: 申し込み後に支払方法が選択されていないパターンはないはずなので「変更」のみ
      this.modalTitle = 'お支払い情報の変更';
    }
    this.$data.selectPayment = this.$props.select;
    if (this.$props.select) {
      this.onClickSelectPayment();
    }
    // console.log('select',this.$props.select);
    (window as any).tokenCreated = this.tokenCreated;
  },
  beforeDestroy() {
    const payjpCheckoutIframeEl: any = document.getElementById('payjp-checkout-iframe');
    if (payjpCheckoutIframeEl) {
      payjpCheckoutIframeEl.parentElement.remove();
    }
    (window as any).tokenCreated = null;
    (window as any).PayjpCheckout = null;
  },
  methods: {
    createdPayjpCheckout() {
      const checkoutEl = document.createElement('script');
      checkoutEl.setAttribute('data-key', process.env.VUE_APP_PJ);
      checkoutEl.setAttribute('id', 'payjp-script');
      checkoutEl.setAttribute('src', 'https://checkout.pay.jp/');
      checkoutEl.setAttribute('class', 'payjp-button');
      checkoutEl.setAttribute('data-lang', 'ja');
      checkoutEl.setAttribute('data-partial', 'true');
      checkoutEl.setAttribute('data-submit-text', '登録');
      checkoutEl.setAttribute('data-on-created', 'tokenCreated');
      checkoutEl.setAttribute('data-name-placeholder', 'ICHIROU TANAKA');
      const myform = this.$refs.creditForm as Element;
      myform.appendChild(checkoutEl);
    },
    onClickSelectPayment() {
      if (this.selectPayment !== this.NOSELECT) {
        this.$data.modalTitle = 'ご登録の確認';
        this.$data.isConfirmScreen = true;
        this.createdPayjpCheckout();
      }
    },
    onClickChangePlan() {
      let token = '';
      if (this.selectPayment === this.CREDIT) {
        const payjpToken: any = document.getElementsByName('payjp-token')[0];
        token = payjpToken.value;
      }
      this.$emit('changePayment', {payment: this.selectPayment, token});
    },
    tokenCreated() {
      this.$data.isConfirmCredit = true;
    },
  },
});
